import { Stack, TextField, Typography } from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";

interface Props {
  email: string;
  onEmailChange: (email: string) => void;
  emailValidationError: string;
  emailCheckError: string | null;
  internalInviteError: string | null;
  onEmailValidationErrorClear: () => void;
}

export function EmailStep(props: Props) {
  const {
    email,
    onEmailChange,
    emailValidationError,
    emailCheckError,
    internalInviteError,
    onEmailValidationErrorClear,
  } = props;

  return (
    <Stack spacing={3} mt={1}>
      <Typography variant="body2" color="text.secondary">
        Enter the email address of the supplier you would like to invite to your
        network.
      </Typography>
      <TextField
        label="Supplier Email"
        type="email"
        value={email}
        onChange={(e) => {
          onEmailChange(e.target.value);
          if (emailValidationError) onEmailValidationErrorClear();
        }}
        required
        fullWidth
        placeholder="supplier@company.com"
        error={!!emailValidationError}
        helperText={emailValidationError}
      />
      <ErrorTypography error={emailCheckError} />
      <ErrorTypography error={internalInviteError} />
    </Stack>
  );
}
